/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link, NavLink, withRouter } from 'react-router-dom';
import Notifications from './notifications';
import './styles.scss';

type PropsType = { location: { pathname: string } };
const menu = [
  {
    icon: 'calendar',
    title: 'Events',
    href: '/events'
  },
  {
    icon: 'users',
    title: 'Customers',
    href: '/customer-database'
  },
  {
    icon: 'credit-card-alt',
    title: 'Payouts',
    href: '/pay'
  },
  {
    icon: 'check',
    title: 'Web check-in',
    href: '/check-in'
  },
  {
    icon: 'puzzle',
    title: 'Integrations',
    href: '/integrations'
  },
  {
    icon: 'sponsor',
    title: 'Sponsors',
    href: '/sponsors'
  },
  {
    icon: 'bell',
    title: 'Notifications',
    href: '/notify'
  },
  {
    icon: 'cog',
    title: 'Settings',
    href: '/settings/account'
  }
];

const menuTemp = [
  {
    icon: 'calendar',
    title: 'Events',
    href: '/events'
  },
  {
    icon: 'users',
    title: 'Customers',
    href: '/customer-database'
  },
  {
    icon: 'credit-card-alt',
    title: 'Payouts',
    href: '/pay'
  },
  {
    icon: 'check',
    title: 'Web check-in',
    href: '/check-in'
  },
  {
    icon: 'puzzle',
    title: 'Integrations',
    href: '/integrations'
  },
  {
    icon: 'sponsor',
    title: 'Sponsors',
    href: '/sponsors'
  },
  {
    icon: 'bell',
    title: 'Notifications',
    href: '/notify'
  },
  {
    icon: 'cog',
    title: 'Settings',
    href: '/settings/account'
  }
];

class LeftNavbar extends React.Component<PropsType> {
  render(): React.ComponentType {
    const { location: { pathname } } = this.props;

    return (
      <aside className="sparxo-sidebar">
        <div className="sidebar-logo1">
          <h1>
            <Link to="/">
              <span className="sparxo-logo2-text" />
            </Link>
          </h1>
          <Link to="/">
            <i className="icon icon-sparxo-logo" style={{ display: 'none' }} />
          </Link>
        </div>
        <div className="sidebar-content">
          <ul className="nav nav-stacked nav-sidebar">
            {_.map(
              _.slice((process.env.NODE_ENV !== 'development' ? menuTemp : menu), 0, -2),
              (item: {}, index: number): React.ComponentType => {
              // TODO CHECK Route in original Dev Server
              if (item.href === '/check-in') {
                return (
                  <li
                    key={`LeftNavbar-${item}-${index}`}
                    className={pathname === item.href ? 'active' : ''}
                  >
                    <a target='_blank' href={item.href} rel="noreferrer noopener">
                      <i className={`icon icon-${item.icon}`} />
                      <span>{item.title}</span>
                    </a>
                  </li>
                );
              }

              return (
                <li
                  key={`LeftNavbar-${item}-${index}`}
                  className={(pathname === item.href || pathname === '/' && item.href === '/events') ? 'active' : ''}
                >
                  <NavLink to={{ pathname: item.href }}>
                    <i className={`icon icon-${item.icon}`} />
                    <span>{item.title}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>

          <ul className="nav nav-stacked nav-sidebar">
            <li>
              <Notifications />
            </li>
            {_.map(
              _.slice((process.env.NODE_ENV !== 'development' ? menuTemp : menu), -1),
              (item: {}, index: number): React.ComponentType => {
              return (
                <li
                  key={`LeftNavbar-${item}-${index}`}
                  className={pathname === item.href ? 'active' : ''}
                >
                  <Link to={{ pathname: item.href }}>
                    <i className={`icon icon-${item.icon}`} />
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </aside>
    );
  }
}


export default withRouter(LeftNavbar);
